import WrapCards from "@/components/cardsWrap";
import { USECASES_CONSTANTS } from "./constants";

const UseCasesComponent = () => {
  return (
    <WrapCards
      title={USECASES_CONSTANTS.title}
      list={USECASES_CONSTANTS.list}
      Width={{
        base: "100%",
        sm: "40vw",
        md: "26vw",
        xl: "16.5vw",
        "2xl": "15vw",
      }}
      spacing={{ base: 8, sm: "4vw", md: "2vw", lg: "2vw", xl: "1vw", "2xl": "2vw" }}
    />
  );
};

export default UseCasesComponent;
